import { QueryClient } from '@tanstack/react-query'
export const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 1000 * 60 * 60 * 24, // 1 day
        cacheTime: 1000 * 60 * 60 * 24, // 1 day
        gcTime: 10 * 60 * 1000, // 10 minutes
      },
    },
  });

export const useGetFetchQuery = (key) => {
    return queryClient
};